module.exports = __webpack_public_path__ + "static/media/empty-state-user.c0c00f35.png";